// Version: 1.0 - Hero Section Component
import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-pattern"></div>
      <div className="container">
        <div className="hero-content">
          <div className="hero-badge fade-in">
            <i className="fa fa-plus-square"></i>
            <span>Concept Emergency Headache Care</span>
          </div>
          
          <h1 className="hero-title slide-up delay-1">
            Specialized <span className="highlight-green">Emergency Care</span> for 
            <span className="highlight-red"> Severe Headaches</span>
          </h1>
          
          <p className="hero-subtitle slide-up delay-2">
            A vision for dedicated emergency headache treatment centers staffed by 
            headache specialists who understand the complexity of acute headache emergencies.
          </p>

          <div className="hero-warning slide-up delay-3">
            <div className="warning-icon">
              <i className="fa fa-info-circle"></i>
            </div>
            <div className="warning-text">
              <strong>This is a concept website.</strong> There is currently no affiliation with any ER facility.
              If you need emergency care, please visit your nearest emergency room.
            </div>
          </div>

          <div className="hero-buttons slide-up delay-4">
            <a href="#find-er" className="btn btn-danger">
              <i className="fa fa-map-marker-alt"></i>
              Find Nearest ER
            </a>
            <a href="#about" className="btn btn-outline">
              <i className="fa fa-info-circle"></i>
              Learn About This Concept
            </a>
          </div>

          <div className="hero-stats slide-up delay-5">
            <div className="stat">
              <span className="stat-number">36M+</span>
              <span className="stat-label">Americans with Migraines</span>
            </div>
            <div className="stat">
              <span className="stat-number">4M+</span>
              <span className="stat-label">ER Visits for Headaches/Year</span>
            </div>
            <div className="stat">
              <span className="stat-number">~4hrs</span>
              <span className="stat-label">Average ER Wait Time</span>
            </div>
          </div>
        </div>
      </div>

      <div className="hero-scroll-indicator">
        <a href="#about" aria-label="Scroll to learn more">
          <span></span>
        </a>
      </div>
    </section>
  );
};

export default Hero;
